import * as React from 'react';
import { Link } from 'react-router-dom';
export default function SimpleLinkCell(_ref) {
  var original = _ref.original,
    value = _ref.value,
    getHref = _ref.column.getHref;
  var href = getHref(original);
  if (href) {
    return /*#__PURE__*/React.createElement(Link, {
      to: href,
      className: "dm-table__link auto-table-link"
    }, value);
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "dm-table__link--inactive"
  }, value);
}